"use client";

import { useEffect, useState } from "react";
import spinners from "unicode-animations";
import type { BrailleSpinnerName } from "unicode-animations";

import { cn } from "@/lib/utils";

export type { BrailleSpinnerName };

export function UnicodeSpinner(props: {
  name?: BrailleSpinnerName;
  className?: string;
  children?: React.ReactNode;
}) {
  const { name = "braille", className, children } = props;
  const spinner = spinners[name];
  const [frame, setFrame] = useState(0);

  useEffect(() => {
    const timer = setInterval(
      () => setFrame((f) => (f + 1) % spinner.frames.length),
      spinner.interval,
    );
    return () => clearInterval(timer);
  }, [name, spinner.frames.length, spinner.interval]);

  return (
    <span
      className={cn("inline-flex items-center gap-1.5 font-mono", className)}
    >
      <span aria-hidden>{spinner.frames[frame]}</span>
      {children}
    </span>
  );
}
